var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PICDraw_groundLineWidth, _PICDraw_centerLineHeight, _PICDraw_themeObserver, _PICDraw_width, _PICDraw_height, _PICDraw_canvasWidth, _PICDraw_canvasHeight;
import { css, html } from 'lit';
import { customElement, numberDecoder, PICBase, stringDecoder } from '../Internals';
import { property, query } from 'lit/decorators.js';
//this should somehow be generic
//possibly with format for each type
//not like this, has namespace conflicts with the way internals exports things... same name in diff files
//export enum SupportedCommandTypes { 'update' , 'clear' , 'update-static-data' }
let PICDraw = class PICDraw extends PICBase {
    get ORIGIN() { return { x: 0, y: 0 }; }
    ;
    set width(iwidth) {
        let widthParser = '100%';
        if (iwidth) {
            if (typeof iwidth == 'number' || iwidth.match(/^-?[0-9]*$/g)) {
                iwidth = parseFloat(iwidth);
                widthParser = iwidth + 'px';
            }
            else
                widthParser = iwidth;
        }
        __classPrivateFieldSet(this, _PICDraw_width, widthParser, "f");
        __classPrivateFieldSet(this, _PICDraw_canvasWidth, parseFloat(widthParser), "f");
        this.requestUpdate();
    }
    get width() {
        return __classPrivateFieldGet(this, _PICDraw_width, "f");
    }
    set height(iheight) {
        let heightParser = '20%';
        if (iheight) {
            if (typeof iheight == 'number' || iheight.match(/^-?[0-9]*$/g)) {
                iheight = parseFloat(iheight);
                heightParser = iheight + 'px';
            }
            else
                heightParser = iheight;
        }
        __classPrivateFieldSet(this, _PICDraw_height, heightParser, "f");
        __classPrivateFieldSet(this, _PICDraw_canvasHeight, parseFloat(heightParser), "f");
        this.requestUpdate();
    }
    get height() {
        return __classPrivateFieldGet(this, _PICDraw_height, "f");
    }
    constructor() {
        var _a, _b;
        super();
        this.units = 'meter';
        this.gridStepWidth = 1000;
        this.gridStepHeight = 1000;
        _PICDraw_groundLineWidth.set(this, 6000);
        _PICDraw_centerLineHeight.set(this, 7000);
        _PICDraw_themeObserver.set(this, void 0);
        this.data = [];
        /** This is filled by commands / other components and always redrawn - id-line */
        this.staticData = new Map();
        this.scale = 1;
        this.offset = this.ORIGIN;
        this.mousePos = this.ORIGIN;
        this.viewportTopLeft = this.ORIGIN;
        this.resetCanvas = true;
        this.lastOffsetRef = this.ORIGIN;
        this.lastMousePosRef = this.ORIGIN;
        this.ZOOM_SENSITIVITY = 500;
        this.isFirst = true;
        this.isDragging = false;
        this.wasDragging = false;
        _PICDraw_width.set(this, void 0);
        _PICDraw_height.set(this, void 0);
        _PICDraw_canvasWidth.set(this, parseInt((_a = this.width) !== null && _a !== void 0 ? _a : '1000'));
        _PICDraw_canvasHeight.set(this, parseInt((_b = this.height) !== null && _b !== void 0 ? _b : '1000'));
        this.xFactor = this.convertUnit(__classPrivateFieldGet(this, _PICDraw_canvasWidth, "f"), this.units, 'meter') / 10;
        this.yFactor = this.convertUnit(__classPrivateFieldGet(this, _PICDraw_canvasHeight, "f"), this.units, 'meter') / 10;
    }
    getParentForSize(child) {
        let parent = child.parentElement;
        if (parent) {
            if (child.classList.contains('tabBody') && parent.classList.contains('body'))
                return parent; // if in tab
            if (['modal-body', 'pic-mainbody'].includes(parent.classList[0]))
                return parent; // if in main view or modal/getans
            let grandparent = this.getParentForSize(parent);
            if (grandparent)
                return grandparent;
        }
        return null;
    }
    calculatePixelsFromCSSUnits(val, prop) {
        var _a;
        let unit = val === null || val === void 0 ? void 0 : val.match(/(%|VH|VW|EM|REM)$/g);
        if (val && unit) {
            let num = parseInt(val);
            let res;
            switch (unit[0]) {
                case '%': {
                    let parentSize = (_a = this.getParentForSize(this)) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()[prop];
                    if (!parentSize)
                        return undefined;
                    res = num * parentSize / 100;
                    break;
                }
                case 'VH':
                    res = num * window.innerHeight / 100;
                    break;
                case 'VW':
                    res = num * window.innerWidth / 100;
                    break;
                case 'EM': {
                    let em = window.getComputedStyle(this).fontSize;
                    res = num * parseFloat(em);
                    break;
                }
                case 'REM':
                    res = num * parseFloat(window.getComputedStyle(document.documentElement).fontSize);
                    break;
                default: return undefined;
            }
            return res;
        }
        return undefined;
    }
    focus() {
    }
    validateSubmit() {
        return true;
    }
    checkAndConsumeInlineData() {
        let iData = this.getAttribute('datafromprogress');
        if (iData) {
            if (Array.isArray(iData))
                this.data = iData;
            else
                this.data = JSON.parse(atob(iData));
            this.requestUpdate();
        }
        this.removeAttribute('datafromprogress');
    }
    connectedCallback() {
        super.connectedCallback();
        this.checkAndConsumeInlineData();
        this.addEventListener('update', this.handleCMDUpdate.bind(this));
        this.addEventListener('clear', this.handleCMDClear.bind(this));
        this.addEventListener('update-static-data', this.handleCMDUpdateStaticData);
        // The grid color is read live off --pic-outline at draw time (see drawGrid).
        // data-theme is applied to <html> asynchronously - GlobUserConfig only learns the
        // saved theme after an incl/settings API call resolves - so this component's first
        // draws can happen before it's set, reading the (correct-at-the-time) light value. A
        // canvas won't repaint on its own once the attribute lands, so watch for it and force
        // a redraw when it actually changes.
        __classPrivateFieldSet(this, _PICDraw_themeObserver, new MutationObserver(() => this.updateCanvas()), "f");
        __classPrivateFieldGet(this, _PICDraw_themeObserver, "f").observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        this.removeEventListener('update', this.handleCMDUpdate.bind(this));
        this.addEventListener('clear', this.handleCMDClear.bind(this));
        (_a = __classPrivateFieldGet(this, _PICDraw_themeObserver, "f")) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    static get styles() {
        const defaultStyle = css `
      :host {
      }
      .outerCanvas {
        border: 1px solid black;
        border-radius: 14px;
        /* width: 100%; */
      }
    `;
        return css `
      ${super.styles}
      ${defaultStyle}
    `;
    }
    handleCMDUpdateStaticData(e) {
        let data = e.detail.data;
        if (!data || !data.id)
            return;
        if (data.action === 'set') {
            this.staticData.set(data.id, data.lines);
        }
        else
            this.staticData.delete(data.id);
        this.updateCanvas();
    }
    handleCMDUpdate(e) {
        let drawDetails = e.detail;
        if (e.detail.data)
            drawDetails = e.detail.data;
        if (this.canvas && this.context && drawDetails.coordinates) {
            this.data.push(drawDetails);
            this.updateCanvas();
        }
    }
    handleCMDClear(e) {
        this.data = [];
        this.resetCanvas = true;
        this.updateCanvas();
    }
    convertUnit(iCoord, from, to) {
        switch (from) {
            case 'millimeter':
            case 'mm':
                iCoord /= 1000;
                break;
            case 'centimeter':
            case 'cm':
                iCoord /= 100;
                break;
            case 'meter':
            case 'm': break;
            case 'inch':
                iCoord /= 0.0254;
                break;
            case 'feet':
                iCoord /= 0.3048;
                break;
        }
        switch (to) {
            case 'millimeter':
            case 'mm':
                iCoord *= 1000;
                break;
            case 'centimeter':
            case 'cm':
                iCoord *= 100;
                break;
            case 'meter':
            case 'm': break;
            case 'inch':
                iCoord *= 39.3700787;
                break;
            case 'feet':
                iCoord *= 3.2808399;
                break;
        }
        return iCoord;
    }
    // canvas is 10m X 10m represented with 1000 x 1000 so 1m = 100, but at any given canvas size this needs to be recalculated
    convertFromRealSpace(iMeter) {
        return {
            x: iMeter.x * this.xFactor,
            y: iMeter.y * this.yFactor
        };
    }
    convertToRealSpace(iMeter) {
        return {
            x: iMeter.x / this.xFactor,
            y: iMeter.y / this.yFactor
        };
    }
    //DrawCoordinates - All coordinates are given in milimeters, canvas is drawn in meters
    dc(iCoord, fromUnit = 'millimeter') {
        return this.convertFromRealSpace({
            x: this.convertUnit(iCoord.x, fromUnit, 'meter'),
            y: this.convertUnit(iCoord.y, fromUnit, 'meter')
        });
    }
    //TranslateCoordinates - this is to draw at ground and center instead of 0,0
    tc(iCoord, iAxis, unit = 'millimeter') {
        let retPoint = this.ORIGIN;
        if (this.context) {
            switch (iAxis) {
                case 'centerGround':
                    retPoint.x = this.context.canvas.width / 2 + this.dc(iCoord, unit).x;
                    retPoint.y = this.context.canvas.height - this.dc({ x: 0, y: 1000 }).y - this.dc(iCoord, unit).y;
                    break;
                default:
                    retPoint = this.dc(iCoord, unit);
                    break;
            }
        }
        else
            retPoint = this.dc(iCoord, unit);
        return retPoint;
    }
    //TranslateCoordinates - this makes drawing react properly to zoom and pan
    tcZoom(iCoord, iAxis, unit = 'millimeter') {
        let retPoint = this.ORIGIN;
        switch (iAxis) {
            case 'centerGround':
                retPoint = this.upscalePoint(this.tc(iCoord, 'centerGround', unit), this.scale);
                break;
            default:
                retPoint = this.upscalePoint(this.tc(iCoord, undefined, unit), this.scale);
                break;
        }
        return retPoint;
    }
    // fitOnce: boolean = true;
    zoomToFit() {
        // let maxX = Math.max(...this.data.map(pl => Math.max(...pl.coordinates.coordinates.map(c => c[0]))));
        // let minX = Math.min(...this.data.map(pl => Math.min(...pl.coordinates.coordinates.map(c => c[0]))));
        // let maxY = Math.max(...this.data.map(pl => Math.max(...pl.coordinates.coordinates.map(c => c[1]))));
        // let minY = Math.min(...this.data.map(pl => Math.min(...pl.coordinates.coordinates.map(c => c[1]))));
        // let coords = {min: {x: this.tc(minX, 'center'), y: this.tc(minY, 'ground')}, max: {x: this.tc(maxX, 'center'), y: this.tc(maxY, 'ground')}};
        // console.log(coords);
        // let zoom = (1 + (1 / (this.canvas.width / coords.max.x))) 
        // this.viewportTopLeft = {x: coords.min.x, y: coords.max.y};
        // this.scale = this.scale * zoom;
        // this.context!.scale(this.scale, this.scale);
        // // this.lastOffsetRef = this.offset;
        // // this.offset = this.addPoints(this.offset, {x: coords.min.x, y: coords.max.y});
        // this.updateCanvas();
        // this.#groundLineWidth;
        // this.#centerLineHeight;
        // let newScale = (1 - 1 /( this.canvas.width / this.dc(this.#groundLineWidth))) + 1;
        // console.log(newScale);
        // this.scale = newScale;
        // this.context!.scale(this.scale, this.scale);
        // console.log('zoomToFit', this.tc(0, 'center'), this.tc(0, 'ground'), this.tc(this.#centerLineHeight, 'center'), this.tc(this.#groundLineWidth, 'ground'))
        // console.log(this.dc(this.#groundLineWidth / 2), this.dc(this.#centerLineHeight));
        // this.updateCanvas();
    }
    drawPolyLine(context, iPoly) {
        if (iPoly.coordinates && iPoly.coordinates.coordinates.length > 0 && iPoly.coordinates.coordinates[0].length > 0) {
            context.beginPath();
            context.strokeStyle = iPoly.color ? iPoly.color : 'blue';
            context.lineWidth = 1;
            context.setLineDash([]);
            iPoly.coordinates.coordinates.forEach(pol => {
                let meGo = this.tc({ x: pol[0], y: pol[1] }, 'centerGround', iPoly.coordinates.unit);
                context.lineTo(meGo.x, meGo.y);
            });
            context.stroke();
        }
        else {
            console.log('poly line, nothing to draw', iPoly);
        }
    }
    // This needs to be in center of canvas but either longer or zoom to fit
    drawCenterLine(context) {
        let to = this.tc(this.ORIGIN, 'centerGround', this.units);
        let from = this.tc(this.ORIGIN, 'centerGround', this.units);
        to.y -= this.dc({ x: 0, y: __classPrivateFieldGet(this, _PICDraw_centerLineHeight, "f") }, 'mm').y;
        context.beginPath();
        context.moveTo(from.x, from.y);
        context.lineTo(to.x, to.y);
        context.setLineDash([10, 5]);
        context.lineWidth = 1;
        context.strokeStyle = 'blue';
        context.stroke();
    }
    drawGroundLine(context) {
        let from = this.tc({ x: -(__classPrivateFieldGet(this, _PICDraw_groundLineWidth, "f") / 2), y: 0 }, 'centerGround', 'mm');
        let to = this.tc({ x: __classPrivateFieldGet(this, _PICDraw_groundLineWidth, "f") / 2, y: 0 }, 'centerGround', 'mm');
        context.beginPath();
        context.moveTo(from.x, from.y);
        context.lineTo(to.x, to.y);
        context.setLineDash([10, 5]);
        context.lineWidth = 1;
        context.strokeStyle = 'red';
        context.stroke();
    }
    drawGrid(canvas, context, hStepSize, vStepSize) {
        let gridSize = { x: canvas.width, y: canvas.height };
        let lineWidth = 1;
        let from = this.ORIGIN;
        let to = this.ORIGIN;
        let steps = this.tcZoom({ x: hStepSize, y: vStepSize }, undefined, this.units);
        if (steps) {
            hStepSize = Math.abs(steps.x);
            vStepSize = Math.abs(steps.y);
        }
        context.beginPath();
        let extraStepsX = parseInt('' + this.offset.x / vStepSize);
        let extraStepsY = parseInt('' + this.offset.y / hStepSize);
        let start = { x: -(extraStepsX * vStepSize), y: -(extraStepsY * hStepSize) };
        let end = { x: gridSize.x + (1 + Math.abs(extraStepsX)) * vStepSize, y: gridSize.y + (1 + Math.abs(extraStepsY)) * hStepSize };
        //vertical lines
        for (let i = start.x; i < end.x; i += vStepSize) {
            from = { x: lineWidth + i + this.offset.x, y: 0 };
            to = { x: lineWidth + i + this.offset.x, y: gridSize.y };
            context.moveTo(from.x, from.y);
            context.lineTo(to.x, to.y);
        }
        //horizontal lines
        for (let i = start.y; i < end.y; i += hStepSize) {
            from = { x: 0, y: lineWidth + i + this.offset.y };
            to = { x: gridSize.x, y: i + lineWidth + this.offset.y };
            context.moveTo(from.x, from.y);
            context.lineTo(to.x, to.y);
        }
        // Canvas draws are imperative snapshots, not CSS - they don't auto-update on theme
        // change, so the color has to be read live off --pic-outline (inherited from :root
        // through the shadow boundary) rather than hardcoded, to pick up the dark override.
        context.strokeStyle = getComputedStyle(this).getPropertyValue('--pic-outline').trim() || '#e0e0e0';
        context.lineWidth = lineWidth;
        context.stroke();
    }
    diffPoints(p1, p2) {
        return { x: p1.x - p2.x, y: p1.y - p2.y };
    }
    addPoints(p1, p2) {
        return { x: p1.x + p2.x, y: p1.y + p2.y };
    }
    downscalePoint(p1, scale) {
        return { x: p1.x / scale, y: p1.y / scale };
    }
    upscalePoint(p1, scale) {
        return { x: p1.x * scale, y: p1.y * scale };
    }
    reset(context) {
        if (context && this.resetCanvas) {
            //TODO: if canvas ratio is not the same as the html dom element ratio, all mouse position calcuclations will be wrong
            context.canvas.width = __classPrivateFieldGet(this, _PICDraw_canvasWidth, "f") * window.devicePixelRatio;
            context.canvas.height = __classPrivateFieldGet(this, _PICDraw_canvasHeight, "f") * window.devicePixelRatio;
            context.scale(window.devicePixelRatio, window.devicePixelRatio);
            this.scale = 1;
            this.context = this.canvas.getContext('2d');
            this.offset = this.ORIGIN;
            this.mousePos = this.ORIGIN;
            this.viewportTopLeft = this.ORIGIN;
            this.lastOffsetRef = this.ORIGIN;
            this.lastMousePosRef = this.ORIGIN;
            this.resetCanvas = false;
        }
    }
    //Pan when offset or scale changes
    panOnScale(context) {
        if (context && this.lastOffsetRef) {
            let offsetDiff = this.downscalePoint(this.diffPoints(this.offset, this.lastOffsetRef), this.scale);
            context.translate(offsetDiff.x, offsetDiff.y);
            this.viewportTopLeft = this.diffPoints(this.viewportTopLeft, offsetDiff);
        }
    }
    //Draw
    draw(context) {
        if (context) {
            // clear canvas but maintain transform
            let storedTransform = context.getTransform();
            context.canvas.width = context.canvas.width;
            // Grid needs to be drawn outside of transform to be infinite
            this.drawGrid(this.canvas, context, this.gridStepWidth, this.gridStepHeight);
            context.setTransform(storedTransform);
            this.drawCenterLine(context);
            this.drawGroundLine(context);
            //static data drawn below other data
            this.staticData.forEach((polyLines) => {
                polyLines.forEach(line => this.drawPolyLine(context, line));
            });
            this.data.forEach(pl => this.drawPolyLine(context, pl));
        }
    }
    mouseMove(event) {
        this.handleUpdateMouse(event);
        if (this.context && this.isDragging) {
            let lastMousePos = this.lastMousePosRef;
            let currentMousePos = { x: event.pageX, y: event.pageY };
            this.lastMousePosRef = currentMousePos;
            let mouseDiff = this.diffPoints(currentMousePos, lastMousePos);
            this.lastOffsetRef = this.offset;
            this.offset = this.addPoints(this.offset, mouseDiff);
            this.updateCanvas();
        }
        else {
        }
    }
    handleUpdateMouse(event) {
        event.preventDefault();
        if (this.canvas) {
            let viewportMousePos = { x: event.clientX, y: event.clientY };
            let topLeftCanvasPos = { x: this.canvas.offsetLeft, y: this.canvas.offsetTop };
            this.mousePos = this.diffPoints(viewportMousePos, topLeftCanvasPos);
        }
    }
    mouseUp(event) {
        this.isDragging = false;
    }
    startPan(event) {
        event.preventDefault();
        this.isDragging = true;
        this.lastMousePosRef = { x: event.pageX, y: event.pageY };
    }
    handleWheel(event) {
        event.preventDefault();
        if (this.context) {
            let zoom = 1 - event.deltaY / this.ZOOM_SENSITIVITY;
            let viewportTopLeftDelta = {
                x: (this.mousePos.x / this.scale) * (1 - 1 / zoom),
                y: (this.mousePos.y / this.scale) * (1 - 1 / zoom)
            };
            let newViewportTopLeft = this.addPoints(this.viewportTopLeft, viewportTopLeftDelta);
            this.context.translate(this.viewportTopLeft.x, this.viewportTopLeft.y);
            this.context.scale(zoom, zoom);
            this.context.translate(-newViewportTopLeft.x, -newViewportTopLeft.y);
            this.viewportTopLeft = newViewportTopLeft;
            this.scale = this.scale * zoom;
            this.updateCanvas();
        }
    }
    firstUpdated() {
        if (this.canvas && !this.context) {
            this.context = this.canvas.getContext('2d');
        }
        // this.isFirst = false;
        let h = this.calculatePixelsFromCSSUnits(__classPrivateFieldGet(this, _PICDraw_height, "f"), 'height');
        if (h !== undefined)
            __classPrivateFieldSet(this, _PICDraw_canvasHeight, h, "f");
        let w = this.calculatePixelsFromCSSUnits(__classPrivateFieldGet(this, _PICDraw_width, "f"), 'width');
        if (w !== undefined)
            __classPrivateFieldSet(this, _PICDraw_canvasWidth, w, "f");
        this.requestUpdate();
    }
    updateCanvas() {
        if (this.canvas) {
            //SetupCanvas
            if (!this.context)
                this.context = this.canvas.getContext('2d');
            //Should it ever reset on draw? - it just makes it sort of awkward
            //FIXME reset data, without resetting position... how?
            this.reset(this.context);
            //Translate
            this.panOnScale(this.context);
            //Draw
            this.draw(this.context);
        }
    }
    updated() {
        this.updateCanvas();
    }
    render() {
        return html `
        <div class="outerContainer">
            <canvas class="outerCanvas"
                width=${__classPrivateFieldGet(this, _PICDraw_canvasWidth, "f")}
                height=${__classPrivateFieldGet(this, _PICDraw_canvasHeight, "f")}
                @mousedown=${this.startPan}
                @mouseup=${this.mouseUp}
                @mousemove=${this.mouseMove}
                @mousewheel=${this.handleWheel}
                @mouseout=${() => {
            if (this.isDragging)
                this.wasDragging = true;
            this.isDragging = false;
        }}
                @mouseenter=${(e) => {
            //If left the canvas while dragging, and mouse is still down, resumse dragging
            if (this.wasDragging && e.buttons === 1)
                this.isDragging = true;
            this.wasDragging = false;
        }}
                
            ></canvas>
        </div>
        `;
    }
};
_PICDraw_groundLineWidth = new WeakMap();
_PICDraw_centerLineHeight = new WeakMap();
_PICDraw_themeObserver = new WeakMap();
_PICDraw_width = new WeakMap();
_PICDraw_height = new WeakMap();
_PICDraw_canvasWidth = new WeakMap();
_PICDraw_canvasHeight = new WeakMap();
__decorate([
    property({ converter: stringDecoder })
], PICDraw.prototype, "units", void 0);
__decorate([
    property({ converter: numberDecoder })
], PICDraw.prototype, "gridStepWidth", void 0);
__decorate([
    property({ converter: numberDecoder })
], PICDraw.prototype, "gridStepHeight", void 0);
__decorate([
    query('.outerCanvas')
], PICDraw.prototype, "canvas", void 0);
__decorate([
    property({ type: String, attribute: 'width', reflect: true })
], PICDraw.prototype, "width", null);
__decorate([
    property({ type: String, attribute: 'height', reflect: true })
], PICDraw.prototype, "height", null);
PICDraw = __decorate([
    customElement('pic-draw')
], PICDraw);
export { PICDraw };
//# sourceMappingURL=PICDraw.js.map